export default function Hero() {
  return (
    <section id="home" className="pt-32 pb-20 px-4 bg-amber-50 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-blue-200/30 to-indigo-200/20 rounded-full blur-3xl -translate-x-48 -translate-y-48"></div>
      <div className="absolute top-1/2 right-0 w-80 h-80 bg-gradient-to-br from-purple-200/30 to-blue-200/20 rounded-full blur-3xl translate-x-40"></div>
      <div className="absolute bottom-0 left-1/2 w-64 h-64 bg-gradient-to-br from-indigo-200/30 to-purple-200/20 rounded-full blur-3xl -translate-x-32"></div>

      <div className="container mx-auto text-center relative z-10">
        <div className="max-w-5xl mx-auto">
          {/* Beautiful Typography */}
          <div className="mb-8">
            <h1 className="text-6xl md:text-8xl font-bold mb-8 leading-tight">
              <span className="bg-clip-text text-transparent" style={{backgroundColor:'#6f8e12'}}>
                Farm Fresh
              </span>
              <br />
              <span className=" bg-clip-text text-transparent" style={{backgroundColor:'#6f8e12'}}>
                 <span className="font-semibold">Salads & Fresh Fruits</span>
              </span>
            </h1>
          </div>

          <p className="text-xl mb-12 max-w-4xl mx-auto leading-relaxed" style={{color:'#6f8e12'}}>
          Experience the vibrant fusion of fresh ingredients, bold flavors, and nutritious goodness.  
          Each salad is lovingly prepared with locally sourced, exotic vegetables and seasonal fresh fruits —  
          adding a natural burst of sweetness and vitality to every bite.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16">
            {/* <button className="bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500 hover:from-blue-600 hover:via-indigo-600 hover:to-purple-600 text-white font-semibold py-4 px-10 rounded-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-blue-500/25 text-lg"> */}
              <a className="border-green-600 text-white font-semibold py-4 px-10 rounded-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-blue-500/25 text-lg" target="blank"  style={{color:'#6f8e12', borderColor: '#6f8e12'}} href="https://www.instagram.com/bite_natures?igsh=MW5na2RhbGV4eWg5aQ==">Instagram: @bite_natures</a>
            {/* </button> */}
            <button className="bg-amber/50 backdrop-blur-sm border-2 border-green-600 text-green-600 font-semibold py-4 px-10 rounded-2xl transition-all duration-300 hover:bg-white/90 text-lg"  style={{borderColor:'#6f8e12'}}>
              Whatsapp: 9879687792
            </button>
          </div>
        </div>

        {/* Hero Image */}
        <div className="mt-16">
          <div className="relative max-w-6xl mx-auto">
            <div className="relative">
              {/* Glow effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-blue-300/20 via-indigo-300/20 to-purple-300/20 rounded-3xl blur-2xl"></div>

              {/* Main image */}
              <div className="relative bg-white rounded-3xl shadow-2xl border border-blue-100 overflow-hidden">
                {/* Decorative header */}
                {/* <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-4 border-b border-blue-100">
                </div> */}

                {/* Content */}
                <div className="p-8">
                  <img
                    src="https://images.pexels.com/photos/5971866/pexels-photo-5971866.jpeg"
                    alt="Fresh salad ingredients and healthy food"
                    className="w-full h-64 md:h-80 object-cover rounded-2xl"
                  />
                </div>
              </div>

              {/* Floating Stats Cards */}
              <div className="absolute -top-4 -left-4 bg-white/95 backdrop-blur-xl p-4 rounded-2xl shadow-xl border border-blue-200">
                <div className="text-2xl font-bold text-green-600">100+</div>
                <div className="text-sm text-green-600">Happy Customers</div>
              </div>
              <div className="absolute -bottom-4 -right-4 bg-white/95 backdrop-blur-xl p-4 rounded-2xl shadow-xl border border-indigo-200">
                <div className="text-2xl font-bold text-green-600">4.7★</div>
                <div className="text-sm text-green-600">Customer Rating</div>
              </div>
              <div className="absolute top-1/2 -left-8 bg-white/95 backdrop-blur-xl p-4 rounded-2xl shadow-xl border border-purple-200">
                <div className="text-2xl font-bold text-green-600">100%</div>
                <div className="text-sm text-green-600">Fresh & nutritious</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
